import api from "../api";

const state = {

};

const getters =  {

};

const mutations = {

};

const actions = {
    loadLiquidacionsMM({commit}, mm){
        return api.inyco.liquidacion(mm);
    },
    loadPdfLiquidacion({commit}, codLiq){
        return api.inyco.pdfLiquidacion(codLiq);
    },
    loadLiquidacionMMLiq({commit}, params) {
        return api.inyco.liquidacionMMLiq(params);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};